import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/video/home-page-video.mp4")